// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  height: 600px;
  width: 100%; /* Adjust as per your layout needs */
}

::ng-deep .leaflet-container {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/ministry/ministry-overview/ministry-overview.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA,EAAA,oCAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF","sourcesContent":[".map-container {\r\n  height: 600px;\r\n  width: 100%; /* Adjust as per your layout needs */\r\n}\r\n\r\n::ng-deep .leaflet-container {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
